import { Link, NavLink } from "react-router-dom";
import '../navbar/Navbar.css'
import {useCartContext} from "../context/CartContext";
import brand_logo from '../../brand_logo.png'
import '../main_root.css';
import {useState} from "react";
import '../main_root.css'
import FormatCurrency from "../Store/FormatCurrency";
import storeItems from "../data/StoreData.json";
import DarkMode from '../../DarkMode/DarkMode'



function Navbar({isOpen}) {
  const {openCart ,WishListQuantity,  cartQuantity ,CartItems ,closeCart} = useCartContext();
  const [activeNav, setActivNav] = useState(false)
  



  const fixedNav= () => {
    if (window.scrollY >= 80) {
    setActivNav(true)
  } else {
    setActivNav(false)
  }
  }
  window.addEventListener('scroll' , fixedNav)


    return (
      <>
        <nav className={activeNav ? " fixed_nav navbar navbar-expand-lg" : " navbar navbar-expand-lg"}>
  <div className="container">
          <NavLink className="navbar-brand" to="/"><img src={brand_logo } alt="brand_logo"/></NavLink>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse links" id="navbarNav">
      <ul className="navbar-nav me-auto">
        <li className="nav-item">
          <NavLink   className="nav-link " aria-current="page" to="/">Home</NavLink>
                        </li>
                        
        <li className="nav-item">
          <NavLink  className="nav-link" to="/Apout">Apout</NavLink>
                        </li>
                        
        <li className="nav-item">
          <NavLink  className="nav-link" to="/Store">Store</NavLink>
        </li>

      <li className="nav-item">
          <NavLink  className="nav-link" to="/Services">Services</NavLink>
      </li>
      <li className="nav-item">
        <NavLink className="nav-link" to="/ContactUs">Contact Us</NavLink>
      </li>      
      </ul>      
      <ul className="navbar-nav">
      
                        
        <li className="nav-item">
          <NavLink  className="nav-link" to="/Login">Login</NavLink>
        </li>

      </ul>            

   <div className=" total fw-bold ">
            {" "}
            {FormatCurrency(
              CartItems.reduce((total, cartItem) => {
                const item = storeItems.find((i) => i.id === cartItem.id);
                return total + (item?.price || 0) * cartItem.quantity;
              }, 0)
            )}
          </div> 
 
   <DarkMode className='a'/>   
</div>
        </div>   
        
</nav>      
                <div className="Cart_container">

<button onClick={()=>openCart()} className="Cart_shopping"><i className="fa-solid fa-cart-shopping"></i>
        <div className="cartQuantity">{cartQuantity}</div>
          </button>

          <Link to="/WishList" className="Cart_shopping"><i className="fa-regular fa-heart"></i>
        <div className="cartWishList">{WishListQuantity}</div>
          </Link>

        </div>
        

      </>


    )
}









export default Navbar;